import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { recordNavigationStartupOnce } from './lib/telemetry';
import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

// Fired once per page load, after the app shell has had a chance to mount —
// see docs/V6_ARCHITECTURE_AND_MIGRATION_PLAN.md §7 (measure, don't guess).
window.addEventListener('load', () => {
  setTimeout(recordNavigationStartupOnce, 0);
});
